import { Button } from 'components/common'
import { ICellRendererParams } from '@ag-grid-community/core'
import { useNavigate } from 'react-router-dom'
import { PAGE_UPDATE_FTP_PROFILE } from 'utils/constants'

type ActionCellRendererProps = {
  params: ICellRendererParams
  isEditor: boolean
  getFtpProfileToDelete: (params: ICellRendererParams) => void
}

const ActionCellRenderer = ({
  params,
  isEditor,
  getFtpProfileToDelete,
}: ActionCellRendererProps) => {
  const navigate = useNavigate()

  const handleEditFtpProfile = (ftpProfileId: string) => {
    navigate(`${PAGE_UPDATE_FTP_PROFILE.path}/${ftpProfileId}`)
    return
  }

  if (!isEditor) {
    return <></>
  }

  return (
    <div className="flex h-full items-center justify-center gap-3">
      <Button
        size="small"
        variant="outline"
        className="w-20"
        buttonText="Edit"
        type="button"
        onClick={() => handleEditFtpProfile(params.data._id)}
      />

      <Button
        size="small"
        className="w-20"
        buttonText="Delete"
        type="button"
        onClick={() => getFtpProfileToDelete(params)}
      />
    </div>
  )
}

export default ActionCellRenderer
